import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import { GetSurveyAction } from '../../store/actions/data-survey.actions';
import { select, Store } from '@ngrx/store';
import { DataSurveyState } from '../../store/reducers/data-survey.reducers';
import {take, takeUntil} from 'rxjs/operators';
import { getCurrentSurvey } from '../../store/selectors/data-survey.selectors';
import { BreadcrumbModel } from '@shared/models/breadcrumb.model';
import { FlowChartDataService } from '../../services/flow-chart-data.service';
import { Subject } from 'rxjs';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { PlatformToolDataSurveyResponseService } from '../../services/platform-tool-data-survey-response.service';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';



@Component({
    standalone: false,
    selector: 'particle-platform-tool-flowchart',
  templateUrl: './platform-tool-flowchart.component.html',
  styleUrls: ['./platform-tool-flowchart.component.scss']
})
export class PlatformToolFlowchartComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  @Input() magicLinkModel: MagicLinkModel;
  @Input() selectedTab: TabModel;
  @Input() invalidateSubject: InvalidateSubject = new InvalidateSubject();
  @Input() handler: IPlatformToolHandler;
  itemId: string;
  items: any[] = [];
  flowchartId: string;
  surveyExecutionId: string;
  surveyId: string;
  ngUnsubscribe = new Subject<void>();
  sections: any;
  fieldDefinitions: any;
  flowchartSections: any;
  flowcharts: any;
  rowItem: any;
  sourceType: any;
  selectedIndex: number;
  canAddNewRow: boolean = false;
  defaultExpansionPanelIndex: number;
  constructor(
    private dataSurveyStore: Store<DataSurveyState>,
    private flowChartDataService: FlowChartDataService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private platformToolDataSurveyResponseService: PlatformToolDataSurveyResponseService,
    private commandService: CommandService
  ) { }

  ngOnInit() {
    this.defaultExpansionPanelIndex = 0;
    this.selectedIndex = this.selectedTab.tabData.SelectedIndex;
    this.init();
  }

  private init() {
    this.items = this.selectedTab.tabData['Items'];
    if (this.selectedTab.tabData['CanAddNewRow']) {
      this.canAddNewRow = true;
    } else { this.canAddNewRow = false; }
    this.itemId = this.items[this.selectedIndex].id;
    this.flowchartId = this.selectedTab.tabData.FlowchartId;
    this.surveyExecutionId = this.selectedTab.tabData.ExecutionId;

    this.surveyId = this.selectedTab.tabData.SurveyId;
    console.log('ItemId', this.itemId);

    this.flowChartDataService.initFlowchartData();
    this.flowChartDataService.surveyId = this.surveyId;
    this.flowChartDataService.setResponseExecutionId(this.surveyExecutionId);
    this.fetchFlowChartResponse();
  }

  fetchFlowChartResponse() {
    const query: any = {};
    query.surveyId = this.surveyId;
    query.itemId = this.itemId;
    query.createPreviewItem = false;
    query.includeAllFlowcharts = false;
    query.includeFlowChartsInfo = true;
    query.includeFirstFlowchart = false;
    query.includeSelectedFlowchart = [this.flowchartId];



    this.fuseSplashScreenService.show();
    this.flowChartDataService.getFlowChartResponseInfoByQueryObj(query).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data => {
        this.fuseSplashScreenService.hide();
        console.log('get flow chart tab info', data);
        this.rowItem = data.row;
        this.fieldDefinitions = data.fieldDefinitions;
        this.flowcharts = data.flowcharts;
        this.flowchartSections = data.flowchartSections;
        this.flowChartDataService.setFieldVisibility(data.fieldVisibilities);
        if (data.flowchartSections && data.flowchartSections[this.flowcharts[0].id]) {
          this.sections = data.flowchartSections[this.flowcharts[0].id]; // this.selectedTabIndex
        }


        this.flowChartDataService.setFlowchartId(this.flowchartId);
        this.sourceType = this.flowcharts[0].sourceType;
        this.flowChartDataService.setSourceType(this.sourceType);
        this.flowChartDataService.fetchCustomDataTypes(this.sourceType);

        this.getFlowchartResponseSections();
      }
      ,
      error => {
        this.fuseSplashScreenService.hide();
        console.error('get flow chart tab info error ', error);
      }
    );
  }


  getFlowchartResponseSections() {
    const query: any = {};
    query.surveyId = this.surveyId;
    query.includeFlowChartsInfo = false;
    query.includeFirstFlowchart = false;
    query.includeSelectedFlowchart = [this.flowchartId];
    query.itemId = this.itemId;
    query.createPreviewItem = false;

    this.fuseSplashScreenService.show();
    this.flowChartDataService.getFlowChartResponseInfoByQueryObj(query).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data => {
        this.fuseSplashScreenService.hide();
        console.log('flowchart get sections', data);
        this.rowItem = data.row;
        this.fieldDefinitions = data.fieldDefinitions;
        this.flowChartDataService.setFieldVisibility(data.fieldVisibilities);
        if (data.flowchartSections && data.flowchartSections[this.flowchartId]) {
          this.sections = data.flowchartSections[this.flowchartId];
        }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('flowchart get sections error', error);
      }
    );

  }

  ngOnDestroy() {
    this.flowChartDataService.destroy();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  valueChanged($event: any) {
    if ($event.action) {
      switch ($event.action.id) {
        case 'ChangePage':
          this.changePage($event);
          break;
      }
    }
  }
  addNewRecord() {
    this.handler.valueChanged({
      action : {id: 'AddNewRecord'}});
  }
   changePage(change: number) {
    if (this.selectedIndex + change < 0 || this.selectedIndex + change + 1 > this.items.length) {return; }
    this.sourceType = null;
    setTimeout(() => {
      this.selectedIndex += change;
      this.init();
    }, 0);
  }

  changeConfirmationStatus(status: string) {
    if (this.rowItem.cells['Status'].value === status) {
      status = '';
    }
    const command = new PlatformCommand('UpdateDataSurveyItemStatusCommand', 'DataSurveyApi');
    command.fieldValues['ItemId'] = this.rowItem.id;
    command.fieldValues['Status'] = status;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
        console.log('Command Response', commandResponse);
        this.fuseSplashScreenService.hide();
        this.fetchFlowChartResponse();
      },
      error => {
        console.error('Failed ToolBarComponent command', error);
        this.fuseSplashScreenService.hide();
      });
  }
  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return true;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return true;
  }

  onLoad() {
  }
}
